// src/pages/auth/SlackSuccess.jsx
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../../components/ui/card';
import { CheckCircle } from 'lucide-react';

export const SlackSuccess = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <Card className="w-96 text-center">
                <CardHeader>
                    <div className="flex justify-center mb-4">
                        <CheckCircle className="h-16 w-16 text-green-500" />
                    </div>
                    <CardTitle>Slack 앱 설치 성공!</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                    <p className="text-gray-700">
                        Paper Insight 앱이 성공적으로 Slack 워크스페이스에 설치되었습니다.
                    </p>
                    <p className="text-gray-700">
                        이제 Paper Insight 봇과 DM을 통해 대화할 수 있습니다.
                    </p>
                    <div className="text-sm text-gray-500 pt-4 border-t border-gray-200 mt-4">
                        <p>참고: 관리자 승인 후 서비스 이용이 가능합니다.</p>
                        <p>문의사항은 관리자에게 연락해 주세요.</p>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};